import { useEffect } from "react";

export default function Redir(props) {
  useEffect(() => {
    window.location.replace(props.path);
  }, []);
  return <div></div>;
}
